/**
 *
 * @param root
 * @returns {{getKey: (function(*): string), createItem: (function(*=): {set: function(*=): void, get: function(*=): any}), getItem: (function(*=, *): any), createItems: (function(*): {[p: string]: any}), setItem: (function(*=, *=): void)}}
 */
export const storageSystem = (root) => {
    const self = {
        getKey: key => `${root}.${key}`,
        getItem: (key, defaultValue) => {
            const serialized = localStorage.getItem(self.getKey(key));
            return serialized !== null ? JSON.parse(serialized) : defaultValue;
        },
        setItem: (key, value) => localStorage.setItem(self.getKey(key), JSON.stringify(value)),
        createItem: (key) => ({
            get: defaultValue => self.getItem(key, defaultValue),
            set: value => self.setItem(key, value),
            modify: (callback, defaultValue) => self.setItem(key, callback(self.getItem(key, defaultValue))),
        }),
        createItems: keys => Object.fromEntries(keys.map(key => ([key, self.createItem(key)]))),
    };

    return self;
};
